module.exports = __webpack_public_path__ + "962cccd11ce8d2654c42a826e80de023.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/face/plugin/images/plugin-img003.png
// module id = 913
// module chunks = 3